export const FETCH_SPACE_ACTIVITIES = 'FETCH_SPACE_ACTIVITIES';
export const FETCH_SPACE_ACTIVITIES_SUCCESS = 'FETCH_SPACE_ACTIVITIES_SUCCESS';
export const FETCH_SPACE_ACTIVITIES_FAILS = 'FETCH_SPACE_ACTIVITIES_FAILS';

export const DELETE_IMAGE = 'DELETE_IMAGE';

export const FETCH_TAX = 'FETCH_TAX';
export const FETCH_TAX_SUCCESS = 'FETCH_TAX_SUCCESS';
export const FETCH_TAX_FAILS = 'FETCH_TAX_FAILS';

export const FETCH_CANCELLATION_POLICIES = 'FETCH_CANCELLATION_POLICIES';
export const FETCH_CANCELLATION_POLICIES_SUCCESS = 'FETCH_CANCELLATION_POLICIES_SUCCESS';
export const FETCH_CANCELLATION_POLICIES_FAILS = 'FETCH_CANCELLATION_POLICIES_FAILS';

export const FETCH_PRICING_OPTIONS = 'FETCH_PRICING_OPTIONS';
export const FETCH_PRICING_OPTIONS_SUCCESS = 'FETCH_PRICING_OPTIONS_SUCCESS';
export const FETCH_PRICING_OPTIONS_FAILS = 'FETCH_PRICING_OPTIONS_FAILS';

export const FETCH_AMENITIES = 'FETCH_AMENITIES'
export const FETCH_AMENITIES_SUCCESS = 'FETCH_AMENITIES_SUCCESS'
export const FETCH_AMENITIES_FAILS = 'FETCH_AMENITIES_FAILS';

export const FETCH_RULES = 'FETCH_RULES';
export const FETCH_RULES_SUCCESS = 'FETCH_RULES_SUCCESS';
export const FETCH_RULES_FAILS = 'FETCH_RULES_FAILS';

export const FETCH_ADDONS = 'FETCH_ADDONS';
export const FETCH_ADDONS_SUCCESS = 'FETCH_ADDONS_SUCCESS';
export const FETCH_ADDONS_FAILS = 'FETCH_ADDONS_FAILS';

export const SUBMIT_SPACE_DETAILS = 'SUBMIT_SPACE_DETAILS';

export const UPDATE_SPACE_DETAILS = 'UPDATE_SPACE_DETAILS';

export const FETCH_SEATING_ARRANGEMENT = 'FETCH_SEATING_ARRANGEMENT';
export const FETCH_SEATING_ARRANGEMENT_SUCCESS = 'FETCH_SEATING_ARRANGEMENT_SUCCESS';
export const FETCH_SEATING_ARRANGEMENT_FAILS = 'FETCH_SEATING_ARRANGEMENT_FAILS';

export const FETCH_SAVINGS = 'FETCH_SAVINGS';
export const FETCH_SAVINGS_SUCCESS = 'FETCH_SAVINGS_SUCCESS';
export const FETCH_SAVINGS_FAILS = 'FETCH_SAVINGS_FAILS';

export const FETCH_SPACEDATA = 'FETCH_SPACEDATA';
export const FETCH_SPACEDATA_SUCCESS = 'FETCH_SPACEDATA_SUCCESS';
export const FETCH_SPACEDATA_FAILS = 'FETCH_SPACEDATA_FAILS';

export const FETCH_SPACEDETAILS = 'FETCH_SPACEDETAILS';
export const FETCH_SPACEDETAILS_SUCCESS = 'FETCH_SPACEDETAILS_SUCCESS';
export const FETCH_SPACEDETAILS_FAILS = 'FETCH_SPACEDETAILS_FAILS';

export const FETCH_PLATFORMDATA = 'FETCH_PLATFORMDATA';
export const FETCH_PLATFORMDATA_SUCCESS = 'FETCH_PLATFORMDATA_SUCCESS';
export const FETCH_PLATFORMDATA_FAILS = 'FETCH_SPACEDETAILS_FAILS';

export const DELETE_SPACEDETAILS = 'DELETE_SPACEDETAILS';

export const FETCH_PACKAGE_TYPE = 'FETCH_PACKAGE_TYPE'
export const FETCH_PACKAGE_TYPE_SUCCESS = 'FETCH_PACKAGE_TYPE_SUCCESS'
export const FETCH_PACKAGE_TYPE_FAILS = 'FETCH_PACKAGE_TYPE_FAILS'

export const UPDATE_SPACEOWNER_DETAILS = 'UPDATE_SPACEOWNER_DETAILS';
export const UPDATE_SPACEOWNER_DETAILS_SUCCESS = 'UPDATE_SPACEOWNER_DETAILS_SUCCESS';
export const UPDATE_SPACEOWNER_DETAILS_FAILS = 'UPDATE_SPACEOWNER_DETAILS_FAILS';

export const FETCH_FILTERSPACENAME = 'FETCH_FILTERSPACENAME';
export const FETCH_FILTERSPACENAME_SUCCESS = 'FETCH_FILTERSPACENAME_SUCCESS';
export const FETCH_FILTERSPACENAME_FAILS = 'FETCH_FILTERSPACENAME_FAILS';

export const CLEAR_FILTERSPACENAME = 'CLEAR_FILTERSPACENAME';

export const CHECK_SPACE_IN_WEEKLY_PICKS = 'CHECK_SPACE_IN_WEEKLY_PICKS';
export const CHECK_SPACE_IN_WEEKLY_PICKS_SUCCESS = 'CHECK_SPACE_IN_WEEKLY_PICKS_SUCCESS';
export const CHECK_SPACE_IN_WEEKLY_PICKS_FAILS = 'CHECK_SPACE_IN_WEEKLY_PICKS_FAILS';
export const CLEAR_SPACE_WEEKLY_PICKS_CHECK = 'CLEAR_SPACE_WEEKLY_PICKS_CHECK';

export const CLEAR_SPACEDETAILS = 'CLEAR_SPACEDETAILS';

export const FETCH_SPACES_STATUS = 'FETCH_SPACES_STATUS'
export const FETCH_SPACES_STATUS_SUCCESS = 'FETCH_SPACES_STATUS_SUCCESS'
export const FETCH_SPACES_STATUS_FAILS = 'FETCH_SPACES_STATUS_FAILS'

export const FETCH_SPACESTATUSDATA = 'FETCH_SPACESTATUSDATA'
export const FETCH_SPACESTATUSDATA_SUCCESS = 'FETCH_SPACESTATUSDATA_SUCCESS'
export const FETCH_SPACESTATUSDATA_FAILS = 'FETCH_SPACESTATUSDATA_FAILS'

export const FETCH_SPACECOUNTRYDATA = 'FETCH_SPACECOUNTRYDATA'
export const FETCH_SPACECOUNTRYDATA_SUCCESS = 'FETCH_SPACECOUNTRYDATA_SUCCESS'
export const FETCH_SPACECOUNTRYDATA_FAILS = 'FETCH_SPACECOUNTRYDATA_FAILS'
export const FETCH_WEEKLY_PICKS = 'FETCH_WEEKLY_PICKS';
export const FETCH_WEEKLY_PICKS_SUCCESS = 'FETCH_WEEKLY_PICKS_SUCCESS';
export const FETCH_WEEKLY_PICKS_FAILS = 'FETCH_WEEKLY_PICKS_FAILS';

export const DELETE_WEEKLY_PICKS = 'DELETE_WEEKLY_PICKS';
export const DELETE_WEEKLY_PICK = 'DELETE_WEEKLY_PICK';

export const WEEKLYPICK_SUBMIT = 'WEEKLYPICK_SUBMIT';
export const WEEKLYPICK_UPDATE = 'WEEKLYPICK_UPDATE';

export const SAVE_WEEKLY_PICKS = 'SAVE_WEEKLY_PICKS';
export const SAVE_WEEKLY_PICKS_SUCCESS = 'SAVE_WEEKLY_PICKS_SUCCESS';
export const SAVE_WEEKLY_PICKS_FAILS = 'SAVE_WEEKLY_PICKS_FAILS';

export const UPDATE_STATUS = 'UPDATE_STATUS';

export const FETCH_MRT_LOCATIONS = 'FETCH_MRT_LOCATIONS';
export const FETCH_MRT_LOCATIONS_SUCCESS = 'FETCH_MRT_LOCATIONS_SUCCESS';
export const FETCH_MRT_LOCATIONS_FAILS = 'FETCH_MRT_LOCATIONS_FAILS';

export const FETCH_SPACE_CATEGORY = 'FETCH_SPACE_CATEGORY';
export const FETCH_SPACE_CATEGORY_SUCCESS = 'FETCH_SPACE_CATEGORY_SUCCESS';
export const FETCH_SPACE_CATEGORY_FAILS = 'FETCH_SPACE_CATEGORY_FAILS';

export const FETCH_PRICING_OPTIONS_DAYS_ARRAY = 'FETCH_PRICING_OPTIONS_DAYS_ARRAY';
export const FETCH_PRICING_OPTIONS_DAYS_ARRAY_SUCCESS = 'FETCH_PRICING_OPTIONS_DAYS_ARRAY_SUCCESS';
export const FETCH_PRICING_OPTIONS_DAYS_ARRAY_FAILS = 'FETCH_PRICING_OPTIONS_DAYS_ARRAY_FAILS';

export const RESET_SPACE_FORM_DATA = 'RESET_SPACE_FORM_DATA';

//filter spaces
export const FETCH_SPACES_BY_FILTER = 'FETCH_SPACES_BY_FILTER';
export const FETCH_SPACES_BY_FILTER_SUCCESS = 'FETCH_SPACES_BY_FILTER_SUCCESS';
export const FETCH_SPACES_BY_FILTER_FAILS = 'FETCH_SPACES_BY_FILTER_FAILS';